import React, { useState } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import {
  TableAction,
  TableWrapper,
  TableCellDefault,
  ModalDeleteConfirm,
} from "App/Component/ui";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables, useFetch } from "App/hooks";
import {
  deleteKelasKunjunganById,
  headCells,
  ModalForm,
  RESET_STATE_KELAS_KUNJUNGAN,
} from "./helpers";
import { STYLE_DEFAULT_MASTER, TYPE_INSTANCE2 } from "App/constants";
import { fetchData } from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

const useStyles = STYLE_DEFAULT_MASTER;

export default function TabKelasKamar() {
  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const [rows, setRows] = useFetch(
    TYPE_INSTANCE2,
    LIST_URL_MASTER.kelas_kunjungan.list
  );

  const [formData, setFormData] = useState(RESET_STATE_KELAS_KUNJUNGAN);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  function clickAdd() {
    setFormData(RESET_STATE_KELAS_KUNJUNGAN);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
      tarif_id: row?.tarif_id,
      status: row?.status,
      remark: row?.remark,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function setNewData() {
    const newData = await fetchData(
      TYPE_INSTANCE2,
      LIST_URL_MASTER.kelas_kunjungan.list
    );
    setRows(newData);
  }

  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteKelasKunjunganById(
              formData.id,
              setNewData,
              setShowModalDeleteConfirm,
              setFormData
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title='Daftar Kelas Kunjungan'
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>
                <TableCell align='left'>{row?.name}</TableCell>
                <TableCell align='left'>{row?.remark}</TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
